'use client';

import * as React from 'react';
import { useHasMounted } from '../hooks/use-has-mounted';

export type ClientOnlyProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export function ClientOnly({
  children,
  fallback,
}: ClientOnlyProps): JSX.Element {
  const hasMounted = useHasMounted();

  if (!hasMounted) {
    return <>{fallback}</>;
  }
  return <>{children}</>;
}
